import { Component, OnInit } from '@angular/core';
import { StreamService } from 'src/app/services/stream.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-stream-discounts',
  templateUrl: './stream-discounts.component.html',
  styleUrls: ['./stream-discounts.component.scss']
})
export class StreamDiscountsComponent implements OnInit {
  public title:string='Global Series Discounts';
  public loadedDiscounts:boolean=false;
  public newDiscount={
    type: 'amount',
    amount: 0,
    code: '',
    global: 1,
    valid_from: '',
    expires_on: '',
    one_per_user: 0,
    max_uses: 0
  };
  public discounts:any=[];
  public showDiscountUsers=[];

  constructor(
    private streamService: StreamService,
    private _notify: MatSnackBar
  ) { }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  ngOnInit() {
    this.getGlobalDiscounts();
  }

  getGlobalDiscounts(){
    this.streamService.getGlobalDiscounts().subscribe(
      res=>{
        this.discounts=res;
        this.loadedDiscounts=true;
      }
    );
  }

  addDiscount(){
    if(
      this.newDiscount.code == ''
      || this.newDiscount.amount < 1
    ) {
      return this.notify('A discount must have at least a code and an amount.', 'OK');
    }
    this.streamService.addGlobalDiscount(this.newDiscount).subscribe(
      res=>{
        this.newDiscount={
          type: 'amount',
          amount: 0,
          code: '',
          global: 1,
          valid_from: '',
          expires_on: '',
          one_per_user: 0,
          max_uses: 0
        };
        this.getGlobalDiscounts();
      }
    );
  }

  deleteDiscount(discountId:number){
    if(confirm('Confirm deletion of this discount?')){
      this.streamService.deleteGlobalDiscount(discountId).subscribe(
        res=>{
          this.getGlobalDiscounts();
        }
      );
    }
  }

}
